module.exports = __webpack_public_path__ + "img/mercer-logo.b0ca85ab.png";